// Library Imports
import React, { Component } from "react";
import ReactTable from "react-table";
import $ from "jquery";
import "react-table/react-table.css";
import "react-toggle/style.css";
// Service Imports
import { LoginService } from "../../services/login.service";
import { ProductService } from "../../services/product.service";
import { ExcelService } from "../Excel/excel";
// Other Imports
import { PopUpPortal } from "../../containers/popups/PopUpPortal";
import {
  success,
  warning,
  successNotification,
  warningNotification,
} from "../notification/notifications";
// Unused Imports
// import { Formik, Field, Form, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import DashboardHeader from "../dashboardheader/dashboardheader";
// import Finxfooter from "../../containers/finxfooter/finxfooter";
// import Toggle from "react-toggle";
// import RestDataSource from "../../services/restdatasource";
// import { RegisterUserService } from "../../services/registration.service";
// import { Global_var } from "../../global/global_var";
// import $ from "jquery";
//import { success, successNotification } from "../notification/notifications";
// import * as FileSaver from "file-saver";
// import * as XLSX from "xlsx";

class ProductListLandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtered: [],
      productID: "",
      productName: "",
      parentProductID: null,
      partnerID: "",
      partner: "",
      isParentProduct: "",
      // buid: 2,
      productDescription: " ",
      productType: "",
      productCode: "",
      productPrice: "",
      isActive: "",
      createdBy: "",
      createdDate: "",
      // lastModifiedBy: "",
      // lastModifiedDate: "",
      productLink: "",
      productAnchor: null,
      productSubtitle: null,
      productLanguage: null,
      providerProductID: null,
      productVideourl: null,
      hasModules: null,
      productThumbnail: "",
      productgriddata: this.props.productDetailsAll,
      loading: true,

      courseName: "",
      isFree: "",
      categoryName: "",
      subCategoryName: "",
      gcubeID: "",
      duration: "",
      // addOnCourses:[],
      // parentCourses:[],
      addOnCourses:[],
      parentCourses:[],
      
    };
  }

  componentDidMount() {
    //console.log("componentDidMount Data : " + this.props.productType);
    this.setState({
      productgriddata: this.props.productDetailsAll,
      loading: true,
    });

    if (localStorage.getItem("reload") === "true") {
      localStorage.setItem("reload", "false");
      // window.location.reload()
      this.props.fetchProductListData();
    }

    this.setState({ loading: false });
  }

  filterCaseInsensitive = ({ id, value }, row) => {
    console.log(id, value, row);
    return row[id] ? row[id].toLowerCase().includes(value.toLowerCase()) : true;
  };
  //row[id] !== undefined ? String(row[id]) === String(filter.value) : true

  handleRole = (event) => {
    this.setState({ roleType: event.target.value });
  };
  handleClick = (value) => {
    this.props.history.push("/ops-edit-course", { product: value });
    // let productID = "productID=" + value.productID;
    // ProductService.fetchLearningPathParentProductIDAssignUser(
    //   productID,
    //   (cb) => {
    //     if (cb.responseListObject.length !== 0) {
    //       warning(
    //         "Product could not be modified since the product is assigned to student(s).",
    //         {
    //           ...warningNotification,
    //           container: "top-center",
    //         }
    //       );
    //     } else {
    //       this.props.history.push("/ops-edit-course", { product: value });
    //       // this.props.history.push("/edit-course", value.productID);
    //     }
    //   }
    // );
  };

  handleaddUsersCourse = (props) => {
    //  var currpage = window.location.href;
    //       //alert(currpage.substring(currpage.lastIndexOf('/') + 1))
    //       if (currpage.substring(currpage.lastIndexOf('/') + 1) == 'course-list' || currpage.substring(currpage.lastIndexOf('/') + 1) == 'course-list#') {
    //         localStorage.setItem("profilebackto", 'course-list')
    //       }
    //       else {
    //         localStorage.setItem("profilebackto", 'admin-dashboard')

    //       }
    localStorage.setItem('myProduct',JSON.stringify(props));

    
    // this.props.history.push("/userbulkupload")
    this.props.history.push("/ops-add-course-student", { product: props });
  };

  handleModulesClick = (value) => {
    //console.log("values" + (value.productID))
    localStorage.setItem("selectedgridproduct", value.productID);

    // setTimeout( function(){ //console.log(localStorage.getItem('selectedgridproduct')) }, 2000);
    this.props.history.push("/modules-list", { product: value });
  };

  exportToCSV = () => {
    let modifiedData = [];
    let data = this.state.respnoseData;

    data.forEach((element) => {
      var data1 = {
        // Name : element.name,
        // UserLoginName: element.userLoginName,
        // MobileNumber: element.mobileNumber,
        // EmailId: element.emailId,
        // ActivateDate: element.activateDate,
        // ExpiryDate: element.expiryDate,
        // CreatedBy: element.createdBy,
        // CreatedDate: element.createdDate,
        // LastModifiedBy: element.lastModifiedBy,
        // LastModifiedDateTime: element.lastModifiedDateTime,
        // IsActive: element.isActive,
        // LastLoginDateTime: element.lastLoginDateTime,
      };
      modifiedData.push(data1);
    });

    ExcelService.ExcelData(modifiedData, "FC-ProductList-");
  };

  stateonpagechange = (props) => {
    this.setState({
      productgriddata: this.props.productDetailsAll,
    });
  };

  stateonfilterchange = (props) => {
    this.setState({
      productgriddata: this.props.productDetailsAll,
    });
  };

  handleStatus = (event, values) => {
    //
    LoginService.TokenUser((res) => {
      if (res.status === "success") {
        localStorage.setItem("jwt-token", res.responseObject);

        // let data = {
        //   productID: values.productID,
        //   productName: values.productName,
        //   isActive: values.isActive === 1 ? 0 : values.isActive === 0 ? 1 : "",
        // };

        let statuss = values.isActive === 1 ? 0 : 1;
        let productIDIsActive =
          "productID=" + values.productID + "&isActive=" + statuss;
        ProductService.deleteIsactiveInactive(productIDIsActive, (cb) => {
          if (cb.status === "success") {
            success(" Status updated successfully!", successNotification);
            // window.location.reload()
            this.props.fetchProductListData();
          } else {
            this.setState({ loading: false });
            warning(
              cb.reasonText ? cb.reasonText : cb.status,
              warningNotification
            );
          }
        });
      }
    });
  };
  handlech = () => {};

  handleGetCourseDetails(productID) {
    // console.log("Product ID", productID);
    let params = "productID=" + productID;

    ProductService.getProductDetailById(params, (res) => {
      // console.log("productName", res.responseObject.productName);
      // console.log("duration", res.responseObject.duration);
      // console.log("responseObject", res.responseObject);
      if (res.status === "success") {
        this.setState({
          loading: false,
          courseName: res.responseObject.productName
            ? res.responseObject.productName
            : "---",
          isFree: res.responseObject.isFree ? res.responseObject.isFree : "---",
          categoryName: res.responseObject.categoryName
            ? res.responseObject.categoryName
            : "---",
          subCategoryName: res.responseObject.subCategoryName
            ? res.responseObject.subCategoryName
            : "---",
          gcubeID: res.responseObject.gcubeID
            ? res.responseObject.gcubeID
            : "---",
          duration: res.responseObject.duration
            ? res.responseObject.duration
            : "---",
            durationType: res.responseObject.durationType
            ? res.responseObject.durationType
            : "---",
          addOnCourses:res.responseObject.childCourseList
            ? res.responseObject.childCourseList
            : [],
          parentCourses:res.responseObject.parentCourseList
            ? res.responseObject.parentCourseList
            : [],  
        });
      } else {
        this.setState({
          loading: false,
          courseName: "",
          isFree: "",
          categoryName: "",
          subCategoryName: "",
          gcubeID: "",
          duration: "",
          durationType:""
        });
      }
    });
  }
  handleLoadMoreParentCourses=()=>{
    window.$("#parentCoursesModal").modal("show");
  }
  handleLoadMoreAddOnCourses=()=>{
    window.$("#addOnCoursesModal").modal("show");
  }
  removeState = () => {
    $(".modal-backdrop").hide();
  }
  render() {
    console.log("PRODUCT LIST DATA", this.props.productDetailsAll);

    return (
      <React.Fragment>
        {this.state.loading && (
          <PopUpPortal
            HidePopup={this.state.loading}
            IsVisible={this.state.loading}
          />
        )}
        <section className="dashboard-tab user-tab pt-50 mb-50">
          <div className="padding-rl-50">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-4 col-sm-4 col-xs-12 col-md-offset-8 pull-right"></div>
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="table-header">
                    <h3>
                      <div className="row">
                        <div className="col-md-8 col-sm-6 col-xs-8">
                          <span className="left-icon">
                            <i className="fa fa-list" aria-hidden="true"></i>
                          </span>{" "}
                          Course List
                        </div>
                        <div className="col-md-4 col-sm-6 col-xs-4">
                          {/* <span className="right-icon">
                            <a>
                            <i onClick={() => this.exportToCSV ( )}

                                className="fa fa-file-excel-o"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </span> */}
                          {/* <span className="right-icon">
                            <a href="/userbulkupload">
                              <i className="fa fa-upload" aria-hidden="true"></i>
                            </a>
                          </span> */}
                          <span className="right-icon">
                            <a title="Add Course" href="/ops-add-course">
                              <i className="fa fa-plus" aria-hidden="true"></i>
                            </a>
                          </span>
                        </div>
                      </div>
                    </h3>
                  </div>
                  <div className="bg-box">
                    <div className="table-responsive">
                      <ReactTable
                        minRows={2}
                        data={this.props.productDetailsAll}
                        //data={this.state.productgriddata ? this.state.productgriddata :  this.props.productDetailsAll }
                        //data={this.state.productgriddata == null ? this.props.productDetailsAll : this.state.productgriddata != null ? this.state.productgriddata : this.props.productDetailsAll  }
                        filtered={this.state.filtered}
                        //onFilteredChange={filtered => {this.setState({ filtered });}}
                        onFilteredChange={(filtered) => {
                          this.setState({
                            filtered: filtered,
                            productgriddata: this.props.productDetailsAll,
                          });
                        }}
                        className="-striped -highlight"
                        filterable
                        onPageChange={this.stateonpagechange}
                        defaultFilterMethod={this.filterCaseInsensitive}
                        ref={(refReactTable) => {
                          this.refReactTable = refReactTable;
                        }}
                        columns={[
                          {
                            columns: [
                              {
                                Header: "Course Name",
                                id: "productName",
                                accessor: (d) => d.productName,
                              },

                              // {
                              //   Header: "Code",
                              //   id: "productCode",
                              //   accessor: (d) =>
                              //     d.productCode ? d.productCode : "---",
                              // },

                              {
                                Header: "Type",
                                id: "productType",
                                accessor: (d) => d.productTypeName?d.productTypeName:"---",

                                // Cell: (props) => {
                                //   let prdtype = JSON.parse(
                                //     localStorage.getItem("productTypeedit")
                                //   );
                                //   let name = this.props.productType
                                //     ? this.props.productType.map((item) =>
                                //         item.codeValueId ===
                                //         props.original.productType
                                //           ? item.codeValue
                                //           : ""
                                //       )
                                //     : prdtype.map((item) =>
                                //         item.codeValueId ===
                                //         props.original.productType
                                //           ? item.codeValue
                                //           : ""
                                //       );
                                //   return <div>{name}</div>;
                                // },
                              },
                              {
                         
                                Header: "Course Type",
                                id: "courseTypeID",
                                // accessor: (d) => d.courseTypeID===1?"Straight Through Course":d.courseTypeID===2?"Selection Based Application":"---",
                                accessor:(d)=>d.courseTypeName?d.courseTypeName:"---"
                                
                               
                                },

                              // {
                              //   Header: "Partner",
                              //   id: "partner",
                              //   accessor: d => d.partner,
                              //   Cell: props => {
                              //     let name = this.props.partner ? this.props.partner.map(item => (
                              //       item.partnerID == props.original.partnerID ? item.partnerName : ''
                              //     )) : "";
                              //     return (
                              //       <div>
                              //         {name}
                              //       </div>
                              //     );
                              //   }
                              // },
                              // {
                              //   Header: "Sequence Number",
                              //   id: "productSequenceNumber",
                              //   filterable: true,
                              //   Cell: (row) => (
                              //     <div style={{ textAlign: "left" }}>
                              //       {row.value}
                              //     </div>
                              //   ),
                              //   accessor: (d) =>
                              //     (
                              //       new Intl.NumberFormat("en-IN").format(
                              //         d.productDisplaySequence
                              //       ) || ""
                              //     ).toString(),
                              //   //accessor: (d) => d.productDisplaySequence.toString(),
                              // },
                              {
                                Header: "Price",
                                id: "productPrice",
                                filterable: true,
                                Cell: (row) => (
                                  <div style={{ textAlign: "right" }}>
                                    {row.value}
                                  </div>
                                ),
                                accessor: (d) =>
                                  (
                                    new Intl.NumberFormat("en-IN", {
                                      style: "currency",
                                      currency: "INR",
                                    }).format(d.productPrice) || ""
                                  ).toString(),
                              },
                              {
                                Header: "GCube ID",
                                id: "gcubeID",
                                accessor: (d) =>
                                  d.gcubeID ? d.gcubeID.toString() : "---",
                              },
                              {
                                Header: "Details",
                                filterable: false,
                                sortable: false,
                                id: "productID",
                                accessor: (d) =>
                                  d.productID ? (
                                    <a
                                      data-toggle="modal"
                                      data-target="#myModalCourse"
                                      href
                                      onClick={() =>
                                        this.handleGetCourseDetails(d.productID)
                                      }
                                    >
                                      {" "}
                                      {/* {d.productID} */}
                                      Display Details
                                    </a>
                                  ) : (
                                    "---"
                                  ),
                              },

                              // {
                              //   Header: "Active",
                              //   id: "isActive",
                              //   filterable: false,
                              //   sortable: false,
                              //   Cell: (props) => {
                              //     return (
                              //       <div>
                              //         <Toggle
                              //           icons={false}
                              //           defaultChecked={
                              //             props.original.isActive === 1
                              //               ? true
                              //               : false
                              //           }
                              //           onChange={(e) =>
                              //             this.handleStatus(e, props.original)
                              //           }
                              //         />
                              //       </div>
                              //     );
                              //   },
                              // },

                              {
                                Header: "Actions",
                                id: "action",
                                filterable: false,
                                sortable: false,
                                Cell: (props) => {
                                  return (
                                    <div>
                                      <a className="mar-left" href>
                                        {
                                          //props.original.isActive == 1 ?
                                          <i
                                            title="Edit Course"
                                            className="fa fa-edit fa-2x "
                                            aria-hidden="true"
                                            onClick={() =>
                                              this.handleClick(props.original)
                                            }
                                          ></i>

                                          //: ''
                                        }
                                      </a>
                                      {/* <a className="mar-left" href="#">
                                        {props.original.isActive === 1 &&
                                        props.original.hasModules > 0 ? (
                                          <i
                                            title="Add Modules"
                                            className="fa fa-eye fa-rx"
                                            onClick={() =>
                                              this.handleModulesClick(
                                                props.original
                                              )
                                            }
                                          ></i>
                                        ) : (
                                          " "
                                        )}
                                      </a>
                                      <a className="mar-left" href="#">
                                        {props.original.isActive === 1 ? (
                                          <i
                                            title="Add Users"
                                            className="fa fa-plus fa-2x"
                                            aria-hidden="true"
                                            onClick={() =>
                                              this.handleaddUsersCourse(
                                                props.original
                                              )
                                            }
                                          ></i>
                                        ) : (
                                          " "
                                        )}
                                      </a> */}
                                    </div>
                                  );
                                },
                              },

                              // {
                              //   // Header: "Modules",
                              //   id: "modules",
                              //   sortable: false,
                              //   filterable: false,
                              //   //accessor: d => d.hasModules,
                              //   Cell: props => {

                              //     let name = props.original.hasModules > 0 ?
                              //       //props.original.isActive == 1 ?
                              //       <a className="mar-left">
                              //         <i className="fa fa-eye fa-rx" onClick={() => this.handleModulesClick(props.original)}>
                              //         </i>
                              //       </a> : ''; //: " ";
                              //     //  <a className="mar-left"><i className="fa fa-eye-slash" aria-hidden="true"></i></a>
                              //     return (
                              //       <div>
                              //         {name}
                              //       </div>)
                              //   }
                              // },
                              // {
                              //   Header: "Assign Users",
                              //   id: "addcourse",
                              //   filterable: false,
                              //   sortable: false,
                              //   Cell: props => {

                              //     return (
                              //       props.original.isActive == 1 ?
                              //         <a className="mar-left">
                              //           <i
                              //             className="fa fa-plus fa-2x"
                              //             aria-hidden="true"
                              //             onClick={() =>
                              //               this.handleaddUsersCourse(props.original)
                              //             }
                              //           ></i>

                              //         </a> : ''
                              //     )
                              //   }
                              // }
                              // {
                              //   Header: "Assign Users",
                              //   id: "Assignuser",
                              //   filterable: false,
                              //   Cell: props => {
                              //     return (
                              //       <a className="mar-left">
                              //         <i
                              //           className="fa fa-eye fa-rx"
                              //           aria-hidden="true"
                              //           onClick={() =>
                              //             this.handlech()
                              //           }
                              //         ></i>

                              //       </a>
                              //     );
                              //   }
                              // },
                            ],
                          },
                        ]}
                        defaultPageSize={10}
                        style={{
                          width: "100%",
                          maxHeight: "500px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- Course Details Modal Starts--> */}

        <div
          className="modal fade"
          id="myModalCourse"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 className="modal-title" id="myModalLabel">
                  Course Details
                </h4>
              </div>
              <div className="modal-body">
                <div className="mb-10">
                  <h2 className="sub-header">
                    Course Name :{" "}
                    <span style={{ color: "black" }}>
                      {this.state.courseName}
                    </span>
                  </h2>
                </div>
                <table className="table table-bordered table-hover table-striped">
                  <thead>
                    <tr>
                      <th
                        className="discount-table-heading"
                        style={{ width: "30%" }}
                      >
                        Is Free
                      </th>
                      <td>{this.state.isFree === "Y" ? "Yes" : "No"}</td>
                    </tr>
                    <tr>
                      <th className="discount-table-heading">Category</th>
                      <td>{this.state.categoryName}</td>
                    </tr>
                    {/* <tr>
                      <th className="discount-table-heading">Sub Category</th>
                      <td>{this.state.subCategoryName}</td>
                    </tr> */}
                    <tr>
                      <th className="discount-table-heading">GCube ID</th>
                      <td>{this.state.gcubeID}</td>
                    </tr>
                    <tr>
                      <th className="discount-table-heading">Duration</th>
                      <td>{this.state.duration}{" "}{this.state.durationType==="hours"?"[hh:mm:ss]":""} </td>
                    </tr>
                    <tr>
                      <th className="discount-table-heading">Add-on Course/s</th>
                        <td>
                           <ul className="location-list">
                                  {
                                    this.state.addOnCourses?.length>0?(this.state.addOnCourses?.slice(0, 3)?.map((item)=>(
                                      <li key={item.productID} title={item.productID}>
                                      <span className="list-item-emoji" role="img" aria-label="Add On Courses">📘</span>
                                  <b style={{color:"#000",fontWeight:"700"}}>
                                  {item.productName}
                                    </b>   
                                    </li>
                                    ))
                                    ):(
                                        <li className="no-locations">
                                          <b style={{color:"#000",fontWeight:"700"}}>
                                           No add-on course found
                                          </b>
                                          </li>
                                      ) 
                                  }
                                    </ul>
                                    {this.state.addOnCourses?.length > 3 && (
                                      <div 
                                      >
                                      <b><a
                                        href
                                        style={{marginLeft:"5px"}}
                                        onClick={()=>{
                                          this.handleLoadMoreAddOnCourses()
                                        }}
                                      >
                                        Load More
                                        </a>
                                        </b>  
                                      </div>
                                                        
                                    )}
                                  </td>
                    </tr>
                    <tr>
                      <th className="discount-table-heading">Parent Course/s</th>
                        <td>
                           <ul className="location-list">
                                  {
                                    this.state.parentCourses?.length>0?(this.state.parentCourses?.slice(0, 3)?.map((item)=>(
                                      <li key={item.productID} title={item.productID}>
                                      <span className="list-item-emoji" role="img" aria-label="Parent Courses">📘</span>
                                  <b style={{color:"#000",fontWeight:"700"}}>
                                  {item.productName}
                                    </b>   
                                    </li>
                                    ))
                                    ):(
                                        <li className="no-locations">
                                          <b style={{color:"#000",fontWeight:"700"}}>
                                          No parent course found
                                          </b>
                                          </li>
                                      ) 
                                  }
                                    </ul>
                                    {this.state.parentCourses?.length > 3 && (
                                      <div 
                                      >
                                      <b><a
                                        href
                                        style={{marginLeft:"5px"}}
                                        onClick={()=>{
                                          this.handleLoadMoreParentCourses()
                                        }}
                                      >
                                        Load More
                                        </a>
                                        </b>  
                                      </div>
                                                        
                                    )}
                                  </td>
                    </tr>
                  </thead>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn discount-table-heading"
                  data-dismiss="modal"
                  style={{
                    float: "right",
                    marginTop: "-30px",
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        {/*Course Details Modal Ends */}
{/*Add On Courses Modal Starts */}
<div class="modal fade" id="addOnCoursesModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"    data-keyboard="false"
              data-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={this.removeState}
        >
          <span aria-hidden="true">&times;</span>
        </button>
     <h4 className="modal-title" id="myModalLabel">
        Add On Courses
      </h4>
      </div>
      <div class="modal-body">
        <ul id="addOnCoursesList" 
        type="location"
        >
        {
           this.state.addOnCourses?.map((item)=>(
            <li key={item.productID} title={item.productID}>
            <span className="list-item-emoji" role="img" aria-label="Add On Courses">📘</span>
        <b style={{color:"#000",fontWeight:"700"}}>
        {item.productName}
          </b>   
          </li>
          ))
           
              }
        </ul>
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>
{/*Add On Courses Modal Ends */}
{/*Parent Courses Modal Starts */}
<div class="modal fade" id="parentCoursesModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"    data-keyboard="false"
              data-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={this.removeState}
        >
          <span aria-hidden="true">&times;</span>
        </button>
     <h4 className="modal-title" id="myModalLabel">
        Parent Courses
      </h4>
      </div>
      <div class="modal-body">
        <ul id="parentCoursesList" 
        type="location"
        >
        {
           this.state.parentCourses?.map((item)=>(
            <li key={item.productID} title={item.productID}>
            <span className="list-item-emoji" role="img" aria-label="Parent Courses">📘</span>
        <b style={{color:"#000",fontWeight:"700"}}>
        {item.productName}
          </b>   
          </li>
          ))
           
              }
        </ul>
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>
{/*Parent Courses Modal Ends */}
      </React.Fragment>
    );
  }
}

export default ProductListLandingPage;
